import { useEffect, useState } from "react";
import { CheckCircle2, AlertCircle, Loader2, MapPin } from "lucide-react";
import { api } from "../lib/api";

export const AddressField = ({ value, onChange, inputClass, testid = "address-input" }) => {
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    const q = (value || "").trim();
    if (q.length < 5) { setStatus("idle"); return undefined; }
    setStatus("loading");
    const t = setTimeout(() => {
      api.get("/geocode", { params: { q } })
        .then((r) => setStatus(r.data.found ? "found" : "missing"))
        .catch(() => setStatus("idle"));
    }, 700);
    return () => clearTimeout(t);
  }, [value]);

  return (
    <div>
      <div className="relative">
        <MapPin size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-wyd-muted" />
        <input data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)}
          placeholder="es. Via Plinio 39" className={`${inputClass} pl-10`} />
      </div>
      <div className="text-xs mt-1.5 min-h-[1rem]" data-testid={`${testid}-status`}>
        {status === "loading" && <span className="text-wyd-muted flex items-center gap-1"><Loader2 size={12} className="animate-spin" /> Cerco l'indirizzo...</span>}
        {status === "found" && <span className="text-wyd-accent flex items-center gap-1"><CheckCircle2 size={12} /> Indirizzo trovato: il puntino sarà nella posizione esatta</span>}
        {status === "missing" && <span className="text-amber-300 flex items-center gap-1"><AlertCircle size={12} /> Indirizzo non trovato: useremo il centro del quartiere</span>}
      </div>
    </div>
  );
};
